import React from 'react';
import { FaCheck, FaClock, FaPlay, FaArrowRight, FaLock } from 'react-icons/fa';

const PhaseCard = ({ phase, status, progress, onClick, isClickable = true }) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'completed':
        return <FaCheck className="status-icon completed" />;
      case 'in-progress':
        return <FaClock className="status-icon in-progress" />;
      case 'current':
        return <FaPlay className="status-icon current" />;
      case 'not-started':
      default:
        return isClickable ? <FaArrowRight className="status-icon ready" /> : <FaLock className="status-icon locked" />;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'completed':
        return 'Completed';
      case 'in-progress':
        return 'In Progress';
      case 'current':
        return 'Current Phase';
      case 'not-started':
      default:
        return isClickable ? 'Ready to Start' : 'Locked';
    }
  };

  const getProgressPercentage = () => {
    if (!progress) return 0;
    return Math.round(progress.completion_percentage || 0);
  };

  const getTaskProgress = () => {
    if (!progress) return { completed: 0, total: 0 };
    return {
      completed: progress.completed_tasks || 0,
      total: progress.total_tasks || 0
    };
  };

  const handleClick = () => {
    if (isClickable && onClick) {
      onClick();
    }
  };

  const taskProgress = getTaskProgress();
  const progressPercentage = getProgressPercentage();

  return (
    <div 
      className={`phase-card ${status} ${isClickable ? 'clickable' : 'locked'}`}
      onClick={handleClick}
    >
      <div className="phase-header">
        <div className="phase-number">
          <span className="phase-icon">{phase.icon}</span>
          <span className="number">{phase.number}</span>
        </div>
        <div className="phase-status">
          {getStatusIcon()}
        </div>
      </div>

      <div className="phase-content">
        <h4 className="phase-name">{phase.name}</h4>
        <p className="phase-description">{phase.description}</p>
        
        {progress && (
          <div className="phase-progress">
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
            <div className="progress-text">
              <span className="percentage">{progressPercentage}%</span>
              <span className="tasks">{taskProgress.completed}/{taskProgress.total} tasks</span>
            </div>
          </div>
        )}

        <div className="phase-footer">
          <span className="status-text">{getStatusText()}</span>
          {isClickable && (
            <FaArrowRight className="arrow-icon" />
          )}
        </div>
      </div>

      {/* Task Preview */}
      {phase.default_tasks && phase.default_tasks.length > 0 && (
        <div className="task-preview">
          <h5>Key Tasks:</h5>
          <ul>
            {phase.default_tasks.slice(0, 2).map((task, index) => (
              <li key={index} className="task-preview-item">
                {progress && progress.tasks && progress.tasks[index] ? (
                  <FaCheck className={`task-icon ${progress.tasks[index].is_completed ? 'completed' : 'pending'}`} />
                ) : (
                  <div className="task-bullet"></div>
                )}
                <span>{task.name}</span>
              </li>
            ))}
            {phase.default_tasks.length > 2 && (
              <li className="task-preview-more">
                +{phase.default_tasks.length - 2} more tasks
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PhaseCard; 